import React from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/logo.png";
import { FaTruck, FaBoxes, FaUserFriends, FaUserShield } from "react-icons/fa";

const Home = () => {
  const storedUser = localStorage.getItem("username");
  const storedBranch = localStorage.getItem("branch");

  const cards = [
    {
      title: "Vehicle Maintenance",
      desc: "Track vehicle kilometers, hours, and diesel usage effortlessly. Optimize maintenance with accurate, real-time data!",
      to: "/temp1",
      icon: <FaTruck />,
      accent: "bg-blue-600",
    },
    {
      title: "Purchase & Inventory",
      desc: "Manage purchases and inventory with precision. Streamline stock tracking for efficient operations.",
      to: "../inventory/indentNoteView",
      icon: <FaBoxes />,
      accent: "bg-emerald-600",
    },
    {
      title: "Admin",
      desc: "Manage members, roles, and day-to-day admin operations.",
      to: "../admin/admin_members_list",
      icon: <FaUserFriends />,
      accent: "bg-indigo-600",
    },
    {
      title: "Super & Admin",
      desc: "Centralized control for masters, configurations, permissions, and system governance.",
      to: "../superAdmin/admin_members_list",
      icon: <FaUserShield />,
      accent: "bg-slate-800",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-100 text-gray-900">
      <div className="bg-white border-b border-gray-200 shadow-sm">
        <div className="max-w-6xl mx-auto px-6 py-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="flex items-center gap-3">
            <img
              src={Logo}
              alt="Logo"
              className="h-12 w-12 rounded-lg shadow object-cover"
            />
            <h1 className="font-dmserif text-2xl md:text-3xl leading-tight">
              HOME
            </h1>
          </div>

          <div className="flex flex-wrap items-center gap-3">
            <div className="px-4 py-2 rounded-xl border bg-gray-50 border-gray-200">
              <p className="text-xs uppercase tracking-wide text-gray-500">
                Username
              </p>
              <p className="font-semibold text-gray-900">{storedUser || "—"}</p>
            </div>
            <div className="px-4 py-2 rounded-xl border bg-gray-50 border-gray-200">
              <p className="text-xs uppercase tracking-wide text-gray-500">
                Branch
              </p>
              <p className="font-semibold text-gray-900">{storedBranch || "—"}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 py-8">
        <div className="p-6 rounded-2xl shadow-xl border bg-white border-gray-200">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">
              Welcome to Home
            </h2>
            <p className="text-gray-600 mt-1">
              Choose a module to continue.
            </p>
          </div>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {cards.map((c) => (
              <Link
                key={c.title}
                to={c.to}
                className="text-left rounded-2xl border p-5 shadow-md hover:shadow-xl transition-all duration-200 transform hover:-translate-y-1 bg-gray-50 border-gray-200 hover:bg-white"
              >
                <div className="flex items-start gap-3">
                  <div
                    className={`w-12 h-12 rounded-xl flex items-center justify-center text-white shadow-lg shrink-0 ${c.accent}`}
                  >
                    <span className="text-lg">{c.icon}</span>
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg text-gray-900">
                      {c.title}
                    </h3>
                    {c.desc ? (
                      <p className="text-sm mt-1 leading-relaxed text-gray-600">
                        {c.desc}
                      </p>
                    ) : null}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;